import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-dialog',
	templateUrl:'./WaDialogPage.html',
	styles: [],
	styleUrls:['./WaDialogPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaDialogPage
{
	mdContent_325 = `\`\`\`java
import com.jwebmp.webawesome.components.dialog.WaDialog;
\`\`\``;
	mdContent_326 = `\`\`\`java
new WaDialog<>()
\`\`\``;
	mdContent_327 = `\`\`\`java
var dialog = new WaDialog<>();
dialog.setLabel("Confirm");
dialog.withHeader("Are you sure?");
dialog.withBody("This action cannot be undone.");
dialog.setOpen(true);
\`\`\``;
}
